import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import PortfolioSection from "../components/PortfolioSection";
import WhyUsSection from "../components/WhyUsSection";
import ProcessSection from "../components/ProcessSection";
import TestimonialsSection from "../components/TestimonialsSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WhatsAppWidget from "../components/WhatsAppWidget";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Static data as fallback
const STATIC_PORTFOLIO = [
  {
    id: "1",
    title: "Vitale Fashion",
    category: "E-Commerce",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&auto=format&fit=crop",
    description: "Tienda de moda online con diseño elegante y experiencia de compra premium",
    url: "https://vitalefashion.com"
  },
  {
    id: "2",
    title: "Dogstoff",
    category: "E-Commerce",
    image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=800&auto=format&fit=crop",
    description: "E-commerce especializado en productos para mascotas",
    url: "https://dogstoff.com"
  },
  {
    id: "3",
    title: "Rozella's Flower",
    category: "Desarrollo Web",
    image: "https://images.unsplash.com/photo-1487530811176-3780de880c2d?w=800&auto=format&fit=crop",
    description: "Florería online con catálogo interactivo y sistema de pedidos",
    url: "https://rozellasflower.com"
  },
  {
    id: "4",
    title: "Blossom Flower Delivery",
    category: "E-Commerce",
    image: "https://images.unsplash.com/photo-1561181286-d3fee7d55364?w=800&auto=format&fit=crop",
    description: "Plataforma de delivery de flores con seguimiento en tiempo real",
    url: "https://www.blossomflowerdelivery.com"
  },
  {
    id: "5",
    title: "Best Pros In Town",
    category: "Desarrollo Web",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&auto=format&fit=crop",
    description: "Directorio de profesionales con sistema de reseñas y reservas",
    url: "https://www.bestprosintown.com"
  },
  {
    id: "6",
    title: "Flowers In 4 Hours",
    category: "E-Commerce",
    image: "https://images.unsplash.com/photo-1508610048659-a06b669e3321?w=800&auto=format&fit=crop",
    description: "Servicio express de entrega de flores con checkout optimizado",
    url: "https://www.flowersin4hours.com"
  },
  {
    id: "7",
    title: "SuperMoney",
    category: "Sistema SaaS",
    image: "https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800&auto=format&fit=crop",
    description: "Plataforma financiera con comparador de préstamos y herramientas de ahorro",
    url: "https://www.supermoney.com"
  },
  {
    id: "8",
    title: "Steven Nicole Salon",
    category: "Desarrollo Web",
    image: "https://images.unsplash.com/photo-1560066984-138dadb4c035?w=800&auto=format&fit=crop",
    description: "Sitio web para salón de belleza con reservas online",
    url: "https://stevennicolesalon.com"
  },
  {
    id: "9",
    title: "The Secret Hair Studio",
    category: "Desarrollo Web",
    image: "https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=800&auto=format&fit=crop",
    description: "Estudio de cabello con galería de trabajos y sistema de citas",
    url: "https://www.thesecrethairstudio.com"
  },
  {
    id: "10",
    title: "Ricci's Salon",
    category: "Desarrollo Web",
    image: "https://images.unsplash.com/photo-1633681926022-84c23e8cb2d6?w=800&auto=format&fit=crop",
    description: "Salón de belleza con booking integrado y galería de estilos",
    url: "https://riccissalon.com"
  },
  {
    id: "11",
    title: "Kate Emilie's Salon",
    category: "Desarrollo Web",
    image: "https://images.unsplash.com/photo-1521590832167-7bcbfaa6381f?w=800&auto=format&fit=crop",
    description: "Experiencia digital premium para salón de belleza exclusivo",
    url: "https://kateemiliessalon.com"
  },
  {
    id: "12",
    title: "Gazelle",
    category: "E-Commerce",
    image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=800&auto=format&fit=crop",
    description: "Marketplace de dispositivos electrónicos reacondicionados",
    url: "https://buy.gazelle.com"
  },
  {
    id: "13",
    title: "Lavo Wash",
    category: "Desarrollo Web",
    image: "https://images.unsplash.com/photo-1520340356584-f9917d1eea6f?w=800&auto=format&fit=crop",
    description: "Servicio de lavado con reservas online y seguimiento de pedidos",
    url: "https://lavowash.com"
  }
];

const STATIC_SERVICES = [
  { id: "web", title: "Desarrollo Web", description: "Sitios web corporativos y e-commerce de alto rendimiento", icon: "Globe" },
  { id: "mobile", title: "Apps Móviles", description: "Aplicaciones nativas iOS y Android", icon: "Smartphone" },
  { id: "saas", title: "Sistemas SaaS", description: "Plataformas personalizadas con IA integrada", icon: "Cpu" },
  { id: "design", title: "Diseño Gráfico", description: "Branding completo y diseño visual premium", icon: "Palette" },
  { id: "marketing", title: "Marketing Digital", description: "SEO, redes sociales y publicidad digital", icon: "TrendingUp" }
];

const STATIC_TESTIMONIALS = [
  {
    id: "1",
    name: "Carlos Mendoza",
    role: "CEO, TechFlow",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&auto=format&fit=crop",
    content: "klyvora7 transformó completamente nuestra presencia digital. Las ventas aumentaron un 280% en los primeros 6 meses.",
    rating: 5
  },
  {
    id: "2",
    name: "Elena Rodríguez",
    role: "Founder, AI Solutions",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&auto=format&fit=crop",
    content: "El nivel de detalle y profesionalismo es excepcional. Nuestra app móvil recibió el premio a mejor UX del año.",
    rating: 5
  },
  {
    id: "3",
    name: "David Sánchez",
    role: "Director, GlobalTech",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&auto=format&fit=crop",
    content: "Invertir en klyvora7 fue la mejor decisión de negocio. ROI de 5x en el primer año.",
    rating: 5
  }
];

const LandingPage = () => {
  const [portfolio, setPortfolio] = useState(STATIC_PORTFOLIO);
  const [testimonials, setTestimonials] = useState(STATIC_TESTIMONIALS);
  const [services, setServices] = useState(STATIC_SERVICES);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Try to fetch from API, but use static data as fallback
    const fetchData = async () => {
      try {
        const [portfolioRes, testimonialsRes, servicesRes] = await Promise.all([
          axios.get(`${API}/portfolio`).catch(() => ({ data: null })),
          axios.get(`${API}/testimonials`).catch(() => ({ data: null })),
          axios.get(`${API}/services`).catch(() => ({ data: null })),
        ]);
        
        if (portfolioRes.data && portfolioRes.data.length > 0) {
          setPortfolio(portfolioRes.data);
        }
        if (testimonialsRes.data && testimonialsRes.data.length > 0) {
          setTestimonials(testimonialsRes.data);
        }
        if (servicesRes.data && servicesRes.data.length > 0) {
          setServices(servicesRes.data);
        }
      } catch (error) {
        console.log("Using static data");
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-[#030303] flex items-center justify-center">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="flex flex-col items-center gap-4"
        >
          <div className="w-12 h-12 border-2 border-[#2979FF] border-t-transparent rounded-full animate-spin" />
          <p className="text-zinc-400 text-sm">Cargando...</p>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#030303] relative overflow-hidden">
      <Navbar />
      <main>
        <HeroSection />
        <ServicesSection services={services} />
        <PortfolioSection portfolio={portfolio} />
        <WhyUsSection />
        <ProcessSection />
        <TestimonialsSection testimonials={testimonials} />
        <ContactSection services={services} />
      </main>
      <Footer />
      <WhatsAppWidget />
    </div>
  );
};

export default LandingPage;
